module.exports = __webpack_public_path__ + "img/join.638c8b5c.png";